import React from 'react';

const Footer = (props) => {
    return (
        <div className="navbar bottom footer">
            <div>Contact</div>
           <div> © 2020 <a href='https://www.jivkoandreev.com/' style={{color:'black'}}> Zhivko Andreev</a></div>
           <div>Privacy</div>
        </div>
    );
}

export default Footer;
